/* eslint-disable @typescript-eslint/no-explicit-any */
import { CardContent, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ModalHeader from '../../Modals/CustomModal/ModalHeader';

interface Props {
  url: any;
  onClose?: any;
  isOpen?: any;
  isAttachmentSigned?: boolean;
}

const ImageModelView = ({
  url,
  onClose,
  isOpen,
  isAttachmentSigned,
}: Props) => {
  const [isImage, setIsImage] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  useEffect(() => {
    if (url) {
      const extension = url.substring(url.lastIndexOf('.') + 1);
      const file_extension = extension.substring(0, extension.lastIndexOf('?'));
      setIsImage(true);
      setIsPdf(true);
      /*  if (
        file_extension == 'jpeg' ||
        file_extension == 'jpg' ||
        file_extension == 'png' ||
        file_extension == 'giff' ||
        file_extension == 'tiff' ||
        file_extension == 'raw' ||
        url.includes('blob:')
      ) {
        setIsImage(true);
      } else if (file_extension === 'pdf') {
        setIsPdf(true);
      } */
    } else {
      setIsImage(false);
      setIsPdf(false);
    }
  }, [url]);

  const handleDownload = async () => {
    const link = document.createElement('a');

    if (isImage) {
      link.href = url;
      link.setAttribute('target', '_blank');
      link.click();
      return;
    }
    const response = await fetch(url);
    const blob = await response.blob();
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', '');
    link.click();
  };

  return (
    <Modal
      onClose={onClose}
      open={isOpen}
      style={{
        // padding: "2.5em",
        paddingLeft: '2em',
        paddingRight: '1em',
        paddingBottom: '1.7em',
        paddingTop: '1em',
        borderRadius: '1em',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        width: '700px',
        height: '630px',
        overflowY: 'auto',
      }}
      hideBackdrop
    >
      <>
        <ModalHeader
          closeModal={onClose}
          modal={{ modal_title: '' }}
          showDownloadButton={true}
          onDownload={() => handleDownload()}
        />
        {/* {isImage && <img src={url} width="680px" height={'580px'} />}
        {isPdf && (
          <iframe src={url} width="100%" height="100%" title="PDF Viewer" />
        )} */}
        <CardContent>
          <iframe
            src={url}
            height="660px"
            width={'100%'}
            // frameborder={'0'}
            title="viewer"
            //border="0"
            // cellspacing="0"
            style={{
              borderStyle: 'none',
              backgroundColor: 'white',
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture full"
          />
        </CardContent>
      </>
    </Modal>
  );
};

export default ImageModelView;
